export default (state = {list:[{name:''}]}, action) => {
    switch (action.type) {
        case 'NEW_DATA_ROW_ACTION':
        return {...action.payload}
        default:
        return state
    }
}
